/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class MySubscriptionsRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  // State
  year = moment().format('YYYY');

  model() {
    let schoolId = this.get('session.activeSchool');
    let subscriberId = this.session.personId;
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    return hash({
      subscriptions: this.store.query('notifications/subscription', {
        schoolId,
        subscriberId,
      }),
      groups: this.store.query('group', { schoolId, year: this.year }),
      tags: this.store.query('posts/tag', { schoolId }),
      tagCategories: this.store.query('posts/tag-category', { schoolId }),
      learners: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
      }),
      learnerPages: this.store.query('posts/page', { type: 1 }), // PageType_LEARNER = 1;
    });
  }
}
